import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useDevAuth } from '@/hooks/useDevAuth';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAdmin?: boolean;
}

export function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { user, loading, userRole } = useAuth();
  const { devUser, isDevMode } = useDevAuth();
  const location = useLocation();

  // Use dev user role if in dev mode
  const currentRole = (isDevMode && devUser?.role) || userRole;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Chargement...
      </div>
    );
  }

  if (!user) {
    const redirectPath = requireAdmin ? '/auth/admin' : '/auth';
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  if (requireAdmin && currentRole !== 'admin_nocodeo') {
    return <Navigate to="/auth/admin" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
